module.exports = __webpack_public_path__ + "img/portrait-022.14dc198c.jpg";